// extracted by mini-css-extract-plugin
module.exports = {"static":"Static_static__3oR8W","title":"Static_title__146ym","desc":"Static_desc__2gA3d"};